import React from "react";
import { Skeleton } from "@material-ui/lab";
import { useSelector } from "react-redux";
import { isEmpty, get } from "lodash";
import ReactPlayer from "react-player";
import Avatar from "../../../components/common/AvtarImage";
import NotFoundPage from "../../../components/common/NotFoundPage";
const _ = { isEmpty, get };

const Home = (props) => {
  const { companyPublicProfile } = useSelector(
    ({ companyPublicView }: any) => companyPublicView.companyPublicView
  );

  const videoCard = (row) => {
    return (
      <div className="video-card">
        <div className="video-player-inner">
          <ReactPlayer
            width="100%"
            height="100%"
            url={`${_.get(row, "url", "")}`}
            controls
          />
        </div>
      </div>
    );
  };

  const companyPeopleCard = (row) => {
    return (
      <div className="leader-card">
        <div className="card-img">
          <Avatar src={_.get(row, "profile_image", "")} />
        </div>
        <div className="card-info">
          <h5>{`${_.get(row, "name", "")}`}</h5>
        </div>
      </div>
    );
  };

  const missionText = _.get(
    companyPublicProfile,
    "companyProfile.mission_and_vision",
    ""
  );
  const hasMissionVision =
    typeof missionText === "string" && missionText.trim().length > 0;
  const hasLeaders = !isEmpty(companyPublicProfile?.companyPeople);
  const hasVideos = (companyPublicProfile?.companyVideos?.length ?? 0) > 0;
  const hasAnyContent = hasMissionVision || hasLeaders || hasVideos;

  if (props.loading) {
    return (
      <div className="tab-wrapper">
        <section className="company-home-section">
          <Skeleton variant="text" width="40%" height={32} />
          <Skeleton variant="rect" width="100%" height={80} style={{ borderRadius: 8 }} />
        </section>
        <section className="company-home-section">
          <Skeleton variant="text" width="30%" height={32} />
          <div className="veiw-cards-wrapper">
            {[1, 2, 3, 4].map((item) => (
              <Skeleton
                key={item}
                variant="rect"
                width="100%"
                height={245}
                style={{ borderRadius: 8 }}
              />
            ))}
          </div>
        </section>
      </div>
    );
  }

  if (!hasAnyContent) {
    return <NotFoundPage content="No content found" />;
  }

  return (
    <div className="tab-wrapper">
      {hasMissionVision && (
        <section className="company-home-section">
          <h2>Our Mission and Vision</h2>
          <div className="company-section-content company-mission-content">
            <p>{missionText}</p>
          </div>
        </section>
      )}
      {!isEmpty(companyPublicProfile?.companyPeople) && (
        <section className="company-home-section">
          <h2>Our Leaders</h2>
          <div className="veiw-cards-wrapper company-leaders-grid">
            {(companyPublicProfile?.companyPeople || []).map((row, index) => (
              <React.Fragment key={row?.id ?? `leader-${index}`}>
                {companyPeopleCard(row)}
              </React.Fragment>
            ))}
          </div>
        </section>
      )}
      {companyPublicProfile?.companyVideos?.length > 0 && (
        <section className="company-home-section">
          <h2>Our Videos</h2>
          <div className="veiw-cards-wrapper company-videos-grid">
            {companyPublicProfile?.companyVideos?.map((row, index) => (
              <React.Fragment key={row?.url ?? `video-${index}`}>
                {videoCard(row)}
              </React.Fragment>
            ))}
          </div>
        </section>
      )}
      {/* <Feed loading={props.loading} /> */}
    </div>
  );
};

export default Home;
